import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"
import { overviewCardsGridSx3 } from "./constants/overviewGrid"
import PlannedSaleCard from "./PlannedSaleCard"
import ExpectedCostCard from "./ExpectedCostCard"
import DeviationAtDateCard from "./DeviationAtDateCard"
import FinalExpectedMarginCard from "./FinalExpectedMarginCard"
import WorkProgressCard from "./WorkProgressCard"
import WorkCertifiedAmountsCard from "./WorkCertifiedAmountsCard"

const ControlVsAvanceSection = ({ data, isLoading }) => {
  const wp = data?.workProgress

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={overviewCardsGridSx3}>
        <WorkCertifiedAmountsCard
          certifiedAccumulated={wp?.certifiedAccumulated ?? 0}
          periodCertified={wp?.periodCertified ?? 0}
          isLoading={isLoading}
          currency={data?.currency}
        />
        <PlannedSaleCard
          saleAmount={wp?.saleAmount ?? 0}
          isLoading={isLoading}
          currency={data?.currency}
        />
        <WorkProgressCard
          percentage={wp?.percentage ?? 0}
          isLoading={isLoading}
        />
        <ExpectedCostCard
          expectedCostAtDate={data?.expectedCostCard?.expectedCostAtDate ?? 0}
          costObjective={data?.expectedCostCard?.costObjective ?? 0}
          advancePercentage={data?.expectedCostCard?.advancePercentage ?? 0}
          hasCertifications={data?.expectedCostCard?.hasCertifications ?? false}
          isLoading={isLoading}
          currency={data?.currency}
        />
        <DeviationAtDateCard
          deviationAtDate={data?.expectedCostCard?.deviationAtDate ?? 0}
          deviationAtDatePercentage={
            data?.expectedCostCard?.deviationAtDatePercentage ?? null
          }
          isLoading={isLoading}
          currency={data?.currency}
        />
        <FinalExpectedMarginCard
          marginAbsolute={data?.finalExpectedMarginCard?.marginAbsolute ?? 0}
          rentabilityPercent={
            data?.finalExpectedMarginCard?.rentabilityPercent ?? null
          }
          vsObjectiveMarginGap={
            data?.finalExpectedMarginCard?.vsObjectiveMarginGap ?? 0
          }
          isLoading={isLoading}
          currency={data?.currency}
        />
      </Box>
    </Box>
  )
}

ControlVsAvanceSection.propTypes = {
  data: PropTypes.shape({
    currency: PropTypes.string,
    workProgress: PropTypes.shape({
      percentage: PropTypes.number,
      certifiedAccumulated: PropTypes.number,
      periodCertified: PropTypes.number,
      saleAmount: PropTypes.number,
    }),
    expectedCostCard: PropTypes.shape({
      expectedCostAtDate: PropTypes.number,
      costObjective: PropTypes.number,
      advancePercentage: PropTypes.number,
      hasCertifications: PropTypes.bool,
      deviationAtDate: PropTypes.number,
      deviationAtDatePercentage: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf([null]),
      ]),
    }),
    finalExpectedMarginCard: PropTypes.shape({
      marginAbsolute: PropTypes.number,
      rentabilityPercent: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf([null]),
      ]),
      vsObjectiveMarginGap: PropTypes.number,
    }),
  }),
  isLoading: PropTypes.bool.isRequired,
}

export default ControlVsAvanceSection
